import { render, staticRenderFns } from "./BullQuarantine.vue?vue&type=template&id=51f04b6a&scoped=true&"
import script from "./BullQuarantine.vue?vue&type=script&lang=js&"
export * from "./BullQuarantine.vue?vue&type=script&lang=js&"
import style0 from "./BullQuarantine.vue?vue&type=style&index=0&id=51f04b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f04b6a",
  null
  
)

export default component.exports